import React from 'react';
import { Alert, Button } from 'antd';
import { UnlockOutlined } from '@ant-design/icons';
import { isRecordKeeper, recordOverrideOn, setRecordOverride, useRecordOverride } from '../utils/recordOverride';

/** Header control. Only the keeper account sees it; every other user gets null. */
export const RecordOverrideButton = () => {
  const on = useRecordOverride();
  if (!isRecordKeeper()) return null;
  return (
    <Button
      size="small"
      type={on ? 'primary' : 'default'}
      danger={on}
      icon={<UnlockOutlined />}
      onClick={() => setRecordOverride(!recordOverrideOn())}
    >
      {on ? 'Editing records' : 'Edit records'}
    </Button>
  );
};

/** Banner on every screen while the keeper override is on. */
export const RecordOverrideBanner = () => {
  const on = useRecordOverride();
  if (!on) return null;
  return (
    <Alert
      type="error"
      showIcon
      banner
      message="Edit records is on: you can change and delete rows on this screen. Turn it off when you finish."
      action={<Button size="small" onClick={() => setRecordOverride(false)}>Turn off</Button>}
    />
  );
};
